import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment-timezone';
import 'moment/locale/id';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_NOTIFICATION from '../../api/apiNotification';
import API_AUTHENTICATION from '../../api/apiAuthentication';
import ActionType from '../../redux/reducer/globalActionType';
import IconTimerMedium from '../../assets/icons/IconTimerMedium';
import IconNotFound from '../../assets/icons/IconNotFound';
import IconTopbarUser from '../../assets/icons/IconTopbarUser';
import IconTopbarNotification from '../../assets/icons/IconTopbarNotification';
import IconTopbarLogout from '../../assets/icons/IconTopbarLogout';
import NexcareLogo from '../../assets/images/nexcare-logo-out.svg';
import Alert from '../Alert/Alert';
import { CheckPermissionApi, CheckPermissionComponent } from '../../util/permission';
import { NOTIFICATION_UPDATE, NOTIFICATION_VIEW } from '../../constants/menuPermissionConstant';
import { closeGrochatWebsocketConnection } from '../../redux/action/grochatWebsocketAction';
import { GroChatVoipContext } from '../GroChatVoipProvider/GroChatVoipProvider';

class Topbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNotification: false,
            notification: [],
            serverTime: '',
            newNotification: false,
            showConfirmAlert: false,
        }
    }

    getServerTime = () => {
        API_NOTIFICATION.getServerTime(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let serverTime = new Date(getContent(res));
                    let currentDate = new Date().getTime();

                    this.realServerTime = setInterval(() => {
                        let endDate = new Date().getTime();
                        let diff = endDate - currentDate;
                        let result = serverTime.getTime() + diff;

                        this.setState({ serverTime: result })
                    }, 1000);
                }
            })
    }

    getNotification = () => {
        if (CheckPermissionApi(NOTIFICATION_VIEW, this.props.userDetail.permissions)) {
            API_NOTIFICATION.getListNotification(1, 10, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            notification: getContent(res),
                            newNotification: res.data.nexsoft.payload.other.new_notification
                        })
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history))
        }
    }

    handleResponseLogout = async () => {
        if (this._isMounted) {
            this.getGroChatVoipContext().hangUp();
            localStorage.clear();
            this.props.history.push('/');
            this.props.handleLogout();
            API_AUTHENTICATION.postDataLogout(this.props.token)
        }
    }

    handleSearch = e => {
        e.preventDefault();
        alert('Fitur Belum Tersedia!');
    }

    handleDropdown = e => {
        if (this.dropdownRef && this.notificationRef && !this.dropdownRef.current.contains(e.target) && !this.notificationRef.current.contains(e.target)) {
            this.setState({
                showNotification: false
            })
        }
    }

    handleOpenNotification = async data => {
        if (!data.is_open && CheckPermissionApi(NOTIFICATION_UPDATE, this.props.userDetail.permissions)) {
            const notifData = {
                updated_at: data.created_at
            }

            await API_NOTIFICATION.putReadNotification(notifData, data.id, this.props.token)
        }

        this.props.history.push(`${ROUTER_CONSTANT.TICKET_DETAIL_ALL.split(':')[0]}${data.ticket_id}`)
        this.setState({ showNotification: false })
    }

    componentDidMount() {
        this._isMounted = true;
        this.dropdownRef = createRef();
        this.notificationRef = createRef();

        this.getServerTime();

        if (localStorage.getItem('isGrochatAuthenticated') === 'true') {
            localStorage.removeItem('isGrochatAuthenticated');
            localStorage.setItem('loginWithGrochatAccount', true);
            window.location.reload();
        }

        if (CheckPermissionApi(NOTIFICATION_VIEW, this.props.userDetail.permissions)) {
            this.getNotification();
            this.intervalNotification = setInterval(() => this.getNotification(), 300000);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showNotification !== this.state.showNotification) {
            if (this.state.showNotification) {
                document.addEventListener('click', this.handleDropdown);
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.realServerTime);
        clearInterval(this.intervalRealTime);
        clearInterval(this.intervalNotification);
        document.removeEventListener('click', this.handleDropdown);
    }

    /**
     * @returns {React.ContextType<GroChatVoipContext>} 
     */
    getGroChatVoipContext = () => {
        return this.context;
    }

    handleLogout = () => {
        if (!this.getGroChatVoipContext().getCall()) {
            this.setState({ showConfirmAlert: true })
        }
    }

    render() {
        return (
            <div className="topbar shadow-md flex justify-between items-center px-10">
                <img src={NexcareLogo} alt="nexcare-logo" className="h-full topbar-logo" />
                <div className="date-time-notification flex items-center">
                    <div className="text-gray-600 ml-5">{this.state.serverTime ? moment.utc(this.state.serverTime).format('DD MMMM YYYY | HH:mm') : 'Sedang Memuat...'}</div>
                    <div className="text-gray-600 ml-5 capitalize">{this.props.userDetail.nexcare_role.replace(/_/g, " ")}</div>
                    <div className="text-gray-600 font-medium ml-5">{this.props.userDetail.first_name} {this.props.userDetail.last_name}</div>
                    <Link to={ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS} className="btnuserprofile ml-5">
                        <IconTopbarUser />
                    </Link>
                    <div className="flex">
                        <CheckPermissionComponent permissionConstant={[NOTIFICATION_VIEW]} userPermission={this.props.userDetail.permissions}>
                            <div className="flex relative ml-5">
                                <div className="cursor-pointer select-none" id="btnnotification" onClick={() => this.setState({ showNotification: !this.state.showNotification })} ref={this.dropdownRef}>
                                    <IconTopbarNotification />
                                    {
                                        this.state.newNotification && <div className="bg-red-500 h-2 w-2 rounded-full absolute top-1 right-1" />
                                    }
                                </div>
                            </div>
                        </CheckPermissionComponent>
                        <div className={this.state.showNotification ? "relative inline-block z-50" : "hidden"} ref={this.notificationRef}>
                            <div className="origin-top-right absolute right-0 mt-10 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none text-gray-600 border border-gray-200">
                                <div className="header border-b-2 border-gray">
                                    <p className="text-center py-4 font-medium">Notifikasi</p>
                                </div>
                                <div className="overflow-y-auto relative" style={{ maxHeight: "70vh" }}>
                                    {
                                        this.state.notification.length > 0
                                            ? this.state.notification.map((notif, idx) =>
                                                <div key={idx}>
                                                    <div className="text-center bg-darkgrey font-medium">{notif.date}</div>
                                                    {
                                                        notif.notifications.map((notifMessage, idx2) =>
                                                            <div className="p-3 border-b-2 border-gray hover:bg-blue-100 cursor-pointer" key={idx2} id="btnopennotification" onClick={() => this.handleOpenNotification(notifMessage)}>
                                                                <p className={notifMessage.is_open ? "text-sm my-1" : "font-bold text-sm my-1"}>Pesan baru dari tiket {notifMessage.ticket_no} oleh {notifMessage.message_from}.</p>
                                                                <p className="font-thin text-xs my-1">{notifMessage.message}.</p>
                                                                <div className="flex items-center text-xs">
                                                                    <IconTimerMedium />
                                                                    <p className="ml-2 text-xs my-1">{moment.utc(notifMessage.created_at).format('HH:mm')}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            )
                                            :
                                            <div className="p-3 border-b-2 border-gray cursor-pointer flex flex-col items-center">
                                                <IconNotFound />
                                                <p className="mt-3">Tidak ada notifikasi</p>
                                            </div>
                                    }
                                    <div className={this.state.notification.length > 0 ? "py-4 bg-white w-full sticky bottom-0" : "hidden"}>
                                        <Link to={ROUTER_CONSTANT.NOTIFICATION} className="font-medium cursor-pointer" id="btnshowallnotification" onClick={() => this.setState({ showNotification: false })}>
                                            <div className="text-center text-xs text-red-400">Lihat Semua <FontAwesomeIcon icon={faChevronDown} /></div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`btnlogout ml-5 ${this.getGroChatVoipContext().getCall() ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`} onClick={this.handleLogout}>
                            <IconTopbarLogout />
                        </div>
                        <Alert show={this.state.showConfirmAlert} icon="logout" button={true} title="Apakah Anda yakin keluar dari aplikasi NexCare?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleResponseLogout()} />
                    </div>
                </div>
            </div>
        );
    }
}

Topbar.contextType = GroChatVoipContext

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail,
        websocket: state.grochatWebsocket.websocket
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT }),
        clearWebsocket: () => dispatch(closeGrochatWebsocketConnection())
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Topbar));